import { thunkProgress } from 'redux-progress';

import type { Dispatch, GetState } from 'model/State';
import { postNoteAccountAPI } from 'modules/mac/duck/api';
import { POST_NOTE_ACCOUNT } from './types';

export const postNoteAccount = (accountId: number, payload: { author: string; body: string }) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  dispatch(thunkProgress(POST_NOTE_ACCOUNT, postNoteAccountAPI(accountId, payload, getState())));
};
